import { graphql } from "@/lib/gql/__generated__/gql";

export const HotelPolicyI18nEditQuery = graphql(/* GraphQL */ `
	query HotelPolicyI18n($hotelID: ID!, $lang: LangCode!) {
		hotelPolicyI18n(hotelID: $hotelID, lang: $lang) {
			id
			lang
			hotelID
			hotelInfo {
				title
				description
			}
			questions {
				questionID
				required
				questionType
				question
				options
			}
			additionalFees {
				additionalID
				name
				price {
					currencyType
					amount
				}
				billingTypeTerm
				billingTypeTarget
				isNotDiscountTarget
				isNotTargetOnDayTrip
				isExcludeCancelFeeTarget
				isExcludedConsumptionTax
				useKidsPrice
				kidsPrices {
					kidsMaxAge
					price {
						currencyType
						amount
					}
				}
				billingTypeTermValidation
				termValidationApplyStartDt
				termValidationApplyEndDt
			}
		}
		customEmailSettingI18n(hotelID: $hotelID, lang: $lang) {
			id
			lang
			hotelID
			reservation {
				atCreated
				atUpdated
				atCanceled
				atCin
			}
			requestReservation {
				atRequest
				atConfirmed
				atDeclined
			}
			shopping {
				atCreated
			}
		}
		hotel(hotelID: $hotelID) {
			email
		}
	}
`);
